import type { BrokenCalcColumn } from './findBrokenCalcColumns';

/** Header tooltip for one blank calc column. */
export function brokenCalcColumnTooltip(brokenCalcColumn: BrokenCalcColumn): string {
  return `This calculated column is blank because its formula references columns not in this report: ${brokenCalcColumn.missingReferences.join(', ')}.`;
}
